import { OpenAIMark, AnthropicMark, GeminiMark, MetaMark, PerplexityMark } from '../landing/BrandLogos';

/**
 * Provider → brand-mark resolver. Inspects the OpenRouter-style model id
 * prefix (e.g. "openai/gpt-4o", "anthropic/claude-sonnet-4-5") and returns
 * the appropriate SVG mark component, or null for unknown providers.
 *
 * Shared by AIHub.jsx, EmptyState, and MessageBubble so the provider
 * affinity is consistent across the chat surface.
 */
export function providerMarkFor(modelId) {
  const id = (modelId || '').toLowerCase();
  if (id.startsWith('openai/')) return OpenAIMark;
  if (id.startsWith('anthropic/')) return AnthropicMark;
  if (id.startsWith('google/')) return GeminiMark;
  if (id.startsWith('meta-llama/')) return MetaMark;
  if (id.startsWith('perplexity/')) return PerplexityMark;
  return null;
}

// Big-name providers surfaced at the top of the model picker.
// Ordered intentionally: GPT → Claude → Gemini → Llama (user request).
export const TOP_PROVIDERS = [
  { key: 'openai',     label: 'OpenAI',    Mark: OpenAIMark    },
  { key: 'anthropic',  label: 'Anthropic', Mark: AnthropicMark },
  { key: 'google',     label: 'Google',    Mark: GeminiMark    },
  { key: 'meta-llama', label: 'Meta',      Mark: MetaMark      },
];
